// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseValidation.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * License Validation component
 */
!(function() {
  require('share/utils/Izenda.StringUtilities');

  var React = require('react');

  var Panel = require('share/components/controls/Izenda.Panel');
  var EmailConstants = require('logic/data/Izenda.EmailConstants');
  var LicenseInfoConstants = require('logic/data/Izenda.LicenseInfoConstants');

  var Validator = require('share/components/hoc/Izenda.Validator');
  var connect = require('share/enhancers/Izenda.Connect');

  var LicenseValidationInput = require('./Izenda.LicenseValidationInput');
  var uiState = require('logic/Izenda.UiState');
  const { isEmpty } = require('lodash/fp');

  var LicenseValidation = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      item: React.PropTypes.object.isRequired
    },
    componentWillReceiveProps: function(nextProps) {
      // Reset license and token status when change connection string
      if (this.props.isValidConnection != nextProps.isValidConnection) {
        this.resetLicenseValidation();
      }
    },
    getLicenseInfo: function() {
      return this.props.store.licenseInfo || {};
    },

    /**
     * Render content
     */
    render: function() {
      var licenseInfo = this.props.item;
      var props = this.props;
      var store = props.store;
      var isLicenseKey = true;
      var localization = props.localization;

      return (
        <Panel header={LicenseInfoConstants.Description} className="panel-default panel-btn-wrapper">
          <LicenseValidationInput store={store} validatedConnection={props.validatedConnection} item={licenseInfo} />
          <fieldset className="form-horizontal" disabled={props.validatedConnection ? null : 'disabled'}>
            <div className="izenda-ActionBarRight u_textRight">
              {uiState.currentUser.systemAdmin && (
                <span className="button-export" onClick={this.exportPerformanceStatisticsTrend}>{localization.getText('COMMON_LABEL_DOWNLOADFILE')}</span>
              )}
              <a className="button-mail" href={EmailConstants.EMAIL.licenseAssistance} >{localization.getText('COMMON_LABEL_SENDEMAIL')}</a>
              <button
                className="btn btn-primary"
                disabled={!licenseInfo.enableValidateButton}
                onClick={this.onValidation}
              >
                {localization.getText('COMMON_LABEL_VALIDATE')}
              </button>
            </div>
          </fieldset>
        </Panel>
      );
    },

    resetLicenseValidation: function() {
      var valManager = this.props.validation;
      valManager.reset('licenseKey');
      valManager.reset('tokenKey');
    },

    onValidation: function(e) {
      e.preventDefault();
      var licenseValidation = this;
      var props = this.props;
      var store = props.store;
      var licenseInfo = this.getLicenseInfo();
      var loader = props.loader;
      loader.startLoading();

      var valManager = this.props.validation;
      var validationFields = licenseInfo.licenseOnlineMode ? 'licenseKey' : ['licenseKey', 'tokenKey'];

      valManager
        .validate(validationFields)
        .then(function(success) {
          return success ? store.validateLicense() : null;
        })
        .then(function(saveErrors) {
          if (!isEmpty(saveErrors)) {
            var message = saveErrors[0] && saveErrors[0].messages && saveErrors[0].messages[0];

            // revert to exited license
            if (!licenseInfo.isValidLicense && licenseInfo.hasValidLicense) {
              props.confirmMessage('info', message).then(function() {
                licenseValidation.resetLicenseValidation();
                return store.getLicenseInformation();
              });
            } else {
              valManager.updateErrors(saveErrors);
            }
          }
          return null;
        })
        .finally(loader.endLoading.bind(loader));
    },

    exportPerformanceStatisticsTrend: function(e) {
      this.props.store.exportPerformanceStatisticsTrend();
    }
  });

  module.exports = connect()(LicenseValidation);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/LicenseChecker/Izenda.LicenseValidation.jsx